import React from "react";
export class ReceiptPrint extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const OrdersList = this.props.CurrentCartOrder || [];
    const CurrentCart = this.props.CurrentCart || [];
    const Company = this.props.CompanyInfo || [];
    return (
      <React.Fragment>
        <div className="container">
          <header className="text-center">
            <label className="company-name">{Company.Name}</label>
            <br />
            {Company.Address}
            <br />
            {Company.Contact ? `Tel: ${Company.Contact}` : ""}
            <br />
            {Company.Email ? `Email: ${Company.Email}` : ""}
            <br />
            {Company.TagLine ? `${Company.TagLine}` : ""}
            <br />
            <table style={{ width: "100%", paddingTop: "5px" }}>
              <tbody>
                <tr>
                  <td>Order ID:</td>
                  <td className="text-right">{CurrentCart.order_id}</td>
                </tr>
                <tr>
                  <td>Table: </td>
                  <td className="text-right">{CurrentCart.table}</td>
                </tr>
                <tr>
                  <td>Waiter:</td>
                  <td className="text-right">{CurrentCart.waiter}</td>
                </tr>
                <tr>
                  <td>Date:</td>
                  <td className="text-right">{CurrentCart.ordertime}</td>
                </tr>
              </tbody>
            </table>
          </header>
          <div className="main-body">
            <div className="info-item-list">
              <table style={{ width: "100%" }}>
                <thead>
                  <th>
                    <strong>
                      Description(
                      {OrdersList.length === 1
                        ? `${OrdersList.length} Item`
                        : `${OrdersList.length} Items`}
                      )
                    </strong>
                  </th>
                  <th>
                    <strong>Qty</strong>
                  </th>
                  <th>
                    <strong>Rate</strong>
                  </th>
                  <th>
                    <strong>Amt</strong>
                  </th>
                </thead>
                <tbody>
                  {OrdersList
                    ? OrdersList.map((order, index) => (
                        <tr key={index}>
                          <td> {order.name}</td>
                          <td className="text-right"> {order.qty} </td>
                          <td className="text-right">{order.price}</td>
                          <td className="text-right">
                            {order.qty * order.price}
                          </td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
              <hr />
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="pad-l-5">Total</td>
                    <td className="text-right" colSpan={3}>
                      {CurrentCart ? CurrentCart.subtotal : 0}/-
                    </td>
                  </tr>
                  <tr>
                    <td className="pad-l-5">
                      Discount{" "}
                      <small>
                        {CurrentCart
                          ? CurrentCart.discount
                            ? CurrentCart.discount.percentage
                            : 0
                          : 0}
                        %
                      </small>
                    </td>
                    <td className="text-right" colSpan={2}>
                      {CurrentCart
                        ? CurrentCart.discount
                          ? CurrentCart.discount.amount
                          : 0
                        : 0}
                      /-
                    </td>
                  </tr>
                  <tr>
                    <td className="pad-l-5">
                      Service Charge{" "}
                      <small>{CurrentCart ? CurrentCart.service : 0}%</small>
                    </td>
                    <td className="text-right" colSpan={2}>
                      {CurrentCart ? CurrentCart.charge : ""}/-
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Grand Total</strong>
                    </td>
                    <td className="text-right">
                      <strong>{CurrentCart ? CurrentCart.total : 0}/-</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>Payment Type</td>
                    <td className="text-right">
                      {CurrentCart.payment ? CurrentCart.payment.type : "Cash"}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-right">Tender</td>
                    <td>{CurrentCart.tender}/-</td>
                  </tr>
                  <tr>
                    <td className="text-right">Change</td>
                    <td>{CurrentCart.change}/-</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr />
            {/*   End of Vat Table   */}
            <footer className="info-client">
              <div className="info-graditude-text text-center border-bottom">
                <p className="text-center">
                  <small>
                    This invoice is not considered as original. Please receive
                    original one after payment.
                  </small>
                  <small>
                    <br />
                    {Company.Website ? `${Company.Website}` : ""}
                  </small>
                </p>
              </div>
            </footer>
          </div>
        </div>

        {/* <table className="table table-borderless"> 
        <thead>
              <tr className="d-flex col-12">
                <th className="col-5">Items {OrdersList?`(`+OrdersList.length+`)`:""}</th> 
                <th className="col text-right">Qty</th>
                <th className="col text-right">Rate</th>
                <th className="col text-right">Total</th>
              </tr>
            </thead>
            <tbody> 
              {OrdersList?OrdersList.map((order,index)=>(
                 <tr className="d-flex col-12" key={index}>
                 <td className="col-5"> {order.name}</td> 
                 <td className="col text-right"> {order.qty} </td>
                 <td className="col text-right">{order.price}</td>
                <td className="col text-right">{order.qty*order.price}</td>
               </tr> 
              )):''} 
            </tbody>
          </table>
          <hr className="hr-sm w-100 mr-0" />
          <table className="table table-borderless">
              <tbody>
              <tr className="d-flex col-12">
               <td className="col">Sub total</td> 
               <td className="col text-right"> रु  {CurrentCart?CurrentCart.subtotal:0}</td>
               <td className="col text-right">Tax <small>{CurrentCart?CurrentCart.tax?CurrentCart.tax_per:0:0}%</small></td>
              <td className="col text-right">रु  {CurrentCart?CurrentCart.tax:0}</td>
             </tr> 
    
             <tr className="d-flex col-12">
               <td className="col">Discount <small>{CurrentCart?CurrentCart.discount?CurrentCart.discount.percentage:0:0}%</small></td> 
               <td className="col text-right">रु {CurrentCart?CurrentCart.discount?CurrentCart.discount.amount:0:0} </td>
               <td className="col text-right">Service Charge <small>{CurrentCart?CurrentCart.service:0}%</small></td>
              <td className="col text-right"> रु  <small>{CurrentCart?CurrentCart.charge:""}</small></td>
             </tr>   
             <tr className="d-flex col-12">
               <td className="col">Tender</td> 
               <td className="col text-right">रु {this.state.cashin}</td>
               <td className="col text-right">Change</td>
              <td className="col text-right">रु {this.state.change}</td>
             </tr>   
              </tbody>
          </table> */}
      </React.Fragment>
    );
  }
}
